import { has, isObject } from 'lodash';

function setRef(node, ref) {
    if (isObject(ref) && has(ref, 'current')) {
        // eslint-disable-next-line no-param-reassign
        ref.current = node;
    } else if (typeof ref === 'function') {
        ref(node);
    }
}

export default function setRefs(...refs) {
    return (node) => refs.forEach((ref) => setRef(node, ref));
}
